<template>
  <div class="resourceUpLoad">
    <!-- <ResourceSelect
      ref="ResourceSelectDialog"
      @submitDialog="selectResource($event)"
    /> -->

    <!-- <label class="title" :class="{ required }">{{ title }}</label> -->

    <el-form-item :label="label" :prop="prop" :required="required">
      <el-upload
        ref="el-upload"
        class="custom-uploader"
        :action="$store.state.appConfig.baseURL + 'api/resource/upload/'"
        :headers="{ 'Access-Token': $store.state.session.token }"
        :data="{ file_type, usage }"
        list-type="picture-card"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload"
        :on-progress="onProgress"
        :disabled="disabled"
      >
        <template v-if="initResourceUrl">
          <el-image
            v-if="checkIsImage(initResourceUrl)"
            :src="initResourceUrl"
            fit="contain"
            class="preview"
            :preview-src-list="[initResourceUrl]"
          >
          </el-image>
          <div
            v-else
            style="
              line-height: 1rem;
              display: flex;
              justify-content: center;
              flex-direction: column;
              height: 100%;
            "
          >
            <i
              class="el-icon-folder"
              style="font-size: 6rem; cursor: pointer"
              @click="disabled && handlePreview()"
            ></i>
          </div>
        </template>

        <div
          v-if="!initResourceUrl && disabled"
          style="
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
          "
        >
          {{l("暂无内容")}}
        </div>

        <i v-if="!disabled" class="custom-uploader-container">
          <el-tooltip
            v-if="initResourceUrl"
            class="custom-uploader-preview"
            effect="light"
            :content="l('查看')"
            placement="top"
          >
            <el-button
              class="el-icon-zoom-in"
              @click.stop="handlePreview"
            ></el-button>
          </el-tooltip>

          <el-tooltip
            class="custom-uploader-delete"
            effect="light"
            :content="l('清空')"
            placement="top"
          >
            <el-button
              class="el-icon-delete"
              @click.stop="$emit('update:initResourceUrl', null)"
            ></el-button>
          </el-tooltip>

          <el-tooltip
            class="custom-uploader-local"
            effect="light"
            :content="l('本地上传')"
            placement="top"
          >
            <el-button class="el-icon-plus"></el-button>
          </el-tooltip>
          <!-- <el-tooltip
            class="custom-uploader-repositories"
            effect="light"
            content="资源库"
            placement="top"
          >
            <el-button
              @click.stop="$refs.ResourceSelectDialog.Show"
              class="el-icon-menu"
            ></el-button>
          </el-tooltip> -->
          <!-- <el-tooltip
            class="custom-uploader-web"
            effect="light"
            content="Web资源"
            placement="top"
          >
            <el-button
              @click.stop="webDialogVisible = true"
              class="el-icon-eleme"
            ></el-button>
          </el-tooltip> -->
        </i>
        <el-progress
          @click.stop
          v-if="uploadProgress"
          type="circle"
          :percentage="uploadProgress"
          :show-text="false"
        ></el-progress>
      </el-upload>
    </el-form-item>

    <el-dialog
      :visible.sync="webDialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <el-form>
        <el-form-item :label="l('Web资源')">
          <el-input
            v-model="webResourceUrl"
            :placeholder="l('请输入资源URL')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="webDialogVisible = false">{{l("取 消")}}</el-button>
        <el-button
          :disabled="!webResourceUrl"
          type="primary"
          @click="
            $emit('update:initResourceUrl', webResourceUrl);
            webDialogVisible = false;
          "
          >{{l("确 定")}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import ResourceSelect from "@/components/common/ResourceSelect.vue";
export default {
  name: "ResourceUpLoad",
  components: {
    // ResourceSelect,
  },
  props: {
    initResourceUrl: String,
    label: String,
    prop: String,
    disabled: Boolean,
    required: Boolean,
    usage: String,
    maxSize: {
      type: Number,
      default: 20, //mb
    },
    file_type: {
      type: String,
      default: "image", //image,wgt,apk,document
    },
  },
  data() {
    return {
      uploadProgress: 0,
      webDialogVisible: false,
      webResourceUrl: this.initResourceUrl,
    };
  },
  watch: {
    //因本Component创建时，initResourceUrl可能还在等接口返回，因此需要监听该值
    initResourceUrl(value) {
      this.webResourceUrl = value;
    },
  },
  mounted() {
    // console.log("this.$utils.type_suffix", this.$utils.type_suffix);
  },
  methods: {
    uploadSuccess(res, file) {
      // console.log(res);
      // console.log(file);
      // console.log(file.raw);
      this.uploadProgress = 0;
      // this.$emit("update:initResourceUrl", URL.createObjectURL(file.raw));
      this.$emit("update:initResourceUrl", res.data);
    },
    uploadError(err, file, fileList) {
      if (err.status == 401) {
        this.$alert(this.l("登录已失效"), this.l("请求出错"), {
          confirmButtonText: this.l("确定"),
          callback: () => {
            this.$store.commit("logout");
          },
        });
      } else {
        this.uploadProgress = 0;
        this.$refs["el-upload"].clearFiles();
        this.$alert(err || this.l("文件上传失败"), this.l("请求出错"), {
          confirmButtonText: this.l("确定"),
        });
      }
    },
    beforeUpload(file) {
      //过滤文件类型
      let nextFlag = false;
      let message = "";

      var fileNameSplitList = file.name.split(".");
      const suffix =
        fileNameSplitList[fileNameSplitList.length - 1].toLowerCase();
      for (var item in this.$utils.type_suffix) {
        if (this.file_type.indexOf(item) != -1) {
          if (this.$utils.type_suffix[item].indexOf(suffix) != -1) {
            nextFlag = true;
          } else {
            message += " " + this.$utils.type_suffix[item] + " ";
          }
        }
      }
      if (!nextFlag) {
        this.$message.error(`${this.l("仅支持")}${message}${this.l("上传")}!`);
        return false;
      }
      //过滤文件大小
      if (this.maxSize) {
        if (file.size / 1024 / 1024 > this.maxSize) {
          this.$message.error(`${this.l("上传资源大小不能超过")} ${this.maxSize}MB!`);
          return false;
        }
      }
      this.uploadProgress = 0.01;
    },
    onProgress(event, file, fileList) {
      this.uploadProgress = event.percent;
    },
    selectResource(e) {
      this.$emit("update:initResourceUrl", e.item.file_url);
    },

    handlePreview() {
      window.open(this.initResourceUrl);
    },

    checkIsImage(url) {
      if (!url) {
        return false;
      }
      var fileNameSplitList = url.split(".");
      var suffix =
        fileNameSplitList[fileNameSplitList.length - 1].toLowerCase();
      if (this.$utils.type_suffix.image.indexOf(suffix) != -1) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$uploaderWidth: 178px;

/deep/label.el-form-item__label {
  font-size: 14px;
  line-height: 40px;
  display: block;
  width: 100%;
  text-align: center;
}

/deep/.custom-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: $uploaderWidth;
    height: $uploaderWidth;
    overflow: hidden;
    display: block;
    margin: 0 auto;
    .custom-uploader-container {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      line-height: $uploaderWidth;
      text-align: center;
      .custom-uploader-preview,
      .custom-uploader-delete,
      .custom-uploader-local,
      .custom-uploader-repositories,
      .custom-uploader-web {
        position: absolute;
        font-size: 36px;
        background: none;
        border: none;
      }
      .custom-uploader-preview {
        display: none;
        top: 0%;
        left: -5%;
      }
      .custom-uploader-delete {
        display: none;
        top: 0%;
        right: -5%;
      }
      .custom-uploader-local {
        color: #ccc;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-left: 0;
      }
      .custom-uploader-repositories {
        display: none;
        bottom: 0%;
        left: -10%;
      }
      .custom-uploader-web {
        display: none;
        bottom: 0%;
        right: -5%;
      }
    }
    .preview {
      width: 100%;
      height: 100%;
      position: absolute;
      display: block;
    }
    .el-progress {
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      .el-progress-circle {
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
  .el-upload:hover {
    border-color: #409eff;
    .custom-uploader-container {
      background: rgba(0, 0, 0, 0.4);
      .custom-uploader-preview,
      .custom-uploader-delete,
      .custom-uploader-local,
      .custom-uploader-repositories,
      .custom-uploader-web {
        display: block;
        color: #fff;
      }
    }
  }
}
/deep/div.el-form-item__error {
  font-size: 14px;
  line-height: 40px;
  display: block;
  width: 100%;
  text-align: center;
}
</style>
